import posthog from "posthog-js";
import "posthog-js/dist/dead-clicks-autocapture";

const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;

if (key && !posthog.__loaded) {
  posthog.init(key, {
    api_host: "/ingest",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    person_profiles: "identified_only",
    capture_pageview: "history_change",
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: true,
    capture_performance: { web_vitals: true, network_timing: true },
    capture_heatmaps: true,
    capture_dead_clicks: true,
    rageclick: true,
    persistence: "localStorage+cookie",
    disable_session_recording: true,
    disable_surveys: true,
  });
  posthog.register({ app: "admin" });
}
